import { render, staticRenderFns } from "./printsendcloudlabel.vue?vue&type=template&id=09793b5c&"
import script from "./printsendcloudlabel.vue?vue&type=script&lang=js&"
export * from "./printsendcloudlabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports